import React from 'react';

import { TournamentMenuItem } from 'app/modules/Navigation/types';

import { useTranslation } from 'app/lang';

import Item from '../TournamentsMenuItems/TournamentMenuItem';

import dictionary from './FavoritesMenuLayer.dictionary.json';

import styles from '../../styles/LeftMenu.module.scss';

type FavoriteTournamentsMenuItemsProps = {
  list: TournamentMenuItem[];
};

const FavoriteTournamentsMenuItems: React.FC<FavoriteTournamentsMenuItemsProps> = ({ list }) => {
  const { t } = useTranslation();

  return (
    <>
      <li className={styles.favoritesGroupTitle}>
        {t(dictionary.tournaments)}
      </li>

      {list.map((item) => (
        <Item entry={item}
              key={item.key} />
      ))}
    </>
  );
};

export default FavoriteTournamentsMenuItems;
